var _defs, _metadata, _rect, _g, _path, _g2, _path2, _g3, _circle, _g4, _circle2, _circle3, _circle4, _circle5, _polygon, _path3, _path4, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2195 1776",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str1 {stroke:black;stroke-width:5.6836}\r\n    .str0 {stroke:black;stroke-width:50.1237}\r\n    .str2 {stroke:black;stroke-width:50.1237;stroke-linecap:round}\r\n    .str3 {stroke:black;stroke-width:50.1237;stroke-linecap:round;stroke-linejoin:round}\r\n    .fil0 {fill:none}\r\n    .fil5 {fill:black}\r\n    .fil1 {fill:#ACACAE}\r\n    .fil2 {fill:#F6C9C3}\r\n    .fil4 {fill:white}\r\n    .fil3 {fill:white;fill-rule:nonzero}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1098 332c-71,-2 -479,14 -713,518 -284,612 247,687 713,687 465,-1 996,-74 712,-687 -234,-504 -642,-520 -712,-518z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_211446784"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 2195,
    height: 1776
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "fil1 str0",
    cx: 489,
    cy: 435,
    r: 313
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    cx: 534,
    cy: 479,
    r: 200
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "fil1 str0",
    cx: 1707,
    cy: 435,
    r: 313
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    cx: 1662,
    cy: 479,
    r: 200
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M1098 332c-71,-2 -479,14 -713,518 -284,612 247,687 713,687 465,-1 996,-74 712,-687 -234,-504 -642,-520 -712,-518z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "fil0 str1",
    cx: 33,
    cy: 556,
    rx: 36,
    ry: 75
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M1098 332c-71,-2 -479,14 -713,518 -284,612 247,687 713,687 465,-1 996,-74 712,-687 -234,-504 -642,-520 -712,-518z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M967 1031l-100 0 0 0 0 -4 0 -5 -1 -4 -1 -4 0 -5 -1 -4 -2 -4 -1 -4 -2 -4 -1 -3 -2 -4 -2 -3 -2 -4 -3 -3 -2 -3 -3 -3 -2 -2 -3 -3 -3 -2 -2 -2 -3 -3 -3 -1 -3 -2 -4 -2 -3 -1 -3 -1 -3 -1 -3 -1 -4 -1 -3 0 -4 0 -3 -1 0 -100 9 0 9 1 9 1 8 2 9 2 8 3 8 3 8 3 8 4 8 4 7 5 7 5 7 5 6 6 6 6 6 6 6 6 5 7 5 7 5 7 4 8 4 7 4 8 3 8 3 8 3 9 2 8 2 9 1 9 1 9 1 9 0 9 0 0zm-172 185l0 -101 0 0 3 0 4 0 3 -1 4 0 3 -1 3 -1 3 -1 3 -2 4 -1 3 -2 3 -2 3 -2 2 -2 3 -2 3 -3 2 -3 3 -2 2 -4 3 -3 2 -3 2 -3 2 -4 1 -4 2 -3 1 -4 2 -4 1 -5 0 -4 1 -4 1 -5 0 -4 0 -5 100 0 0 10 -1 9 -1 9 -1 9 -2 8 -2 9 -3 8 -3 9 -3 8 -4 8 -4 7 -4 8 -5 7 -5 7 -5 7 -6 6 -6 6 -6 6 -6 6 -7 5 -7 5 -7 4 -8 5 -8 3 -8 4 -8 3 -8 3 -9 2 -8 1 -9 2 -9 0 -9 1 0 0zm-172 -185l100 0 0 0 0 5 0 4 1 5 0 4 1 4 1 5 2 4 1 4 2 3 1 4 2 4 2 3 2 3 3 3 2 4 2 2 3 3 3 3 2 2 3 2 3 2 3 2 3 2 3 1 3 2 4 1 3 1 3 1 4 0 3 1 3 0 4 0 0 101 -9 -1 -9 0 -9 -2 -9 -1 -8 -2 -9 -3 -8 -3 -8 -4 -7 -3 -8 -5 -7 -4 -7 -5 -7 -5 -6 -6 -6 -6 -6 -6 -6 -6 -5 -7 -5 -7 -5 -7 -4 -8 -4 -7 -4 -8 -3 -8 -3 -9 -3 -8 -2 -9 -2 -8 -1 -9 -1 -9 -1 -9 0 -10 0 0zm172 -184l0 100 0 0 -4 1 -3 0 -3 0 -4 1 -3 1 -3 1 -4 1 -3 1 -3 2 -3 2 -3 1 -3 3 -3 2 -2 2 -3 3 -3 2 -2 3 -2 3 -3 3 -2 4 -2 3 -2 4 -1 3 -2 4 -1 4 -2 4 -1 4 -1 5 0 4 -1 4 0 5 0 4 -100 0 0 -9 1 -9 1 -9 1 -9 2 -9 2 -8 3 -9 3 -8 3 -8 4 -8 4 -7 4 -8 5 -7 5 -7 5 -7 6 -6 6 -6 6 -6 6 -6 7 -5 7 -5 7 -5 8 -4 7 -4 8 -3 8 -3 9 -3 8 -2 9 -2 9 -1 9 -1 9 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil4",
    d: "M795 897c67,0 122,60 122,134 0,74 -55,134 -122,134 -68,0 -122,-60 -122,-134 0,-74 54,-134 122,-134z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 829,
    cy: 1033,
    r: 111
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M1228 1031l0 0 1 -9 0 -9 1 -9 2 -9 2 -9 2 -8 2 -9 3 -8 4 -8 3 -8 4 -7 5 -8 4 -7 5 -7 6 -7 5 -6 6 -6 6 -6 7 -6 6 -5 7 -5 8 -5 7 -4 8 -4 8 -3 8 -3 8 -3 9 -2 9 -2 8 -1 9 -1 9 0 0 100 -3 1 -4 0 -3 0 -3 1 -4 1 -3 1 -3 1 -3 1 -3 2 -3 2 -3 1 -3 3 -3 2 -3 2 -2 3 -3 2 -3 3 -2 3 -2 3 -2 4 -2 3 -2 4 -2 3 -2 4 -1 4 -1 4 -1 4 -1 5 -1 4 0 4 -1 5 0 4 0 0 -100 0zm172 185l0 0 -9 -1 -9 0 -8 -2 -9 -1 -9 -2 -8 -3 -8 -3 -8 -4 -8 -3 -7 -5 -8 -4 -7 -5 -6 -5 -7 -6 -6 -6 -6 -6 -5 -6 -6 -7 -5 -7 -4 -7 -5 -8 -4 -7 -3 -8 -4 -8 -3 -9 -2 -8 -2 -9 -2 -8 -2 -9 -1 -9 0 -9 -1 -10 100 0 0 5 1 4 0 5 1 4 1 4 1 5 1 4 1 4 2 3 2 4 2 4 2 3 2 3 2 3 2 4 3 2 3 3 2 3 3 2 3 2 3 2 3 2 3 2 3 1 3 2 3 1 3 1 4 1 3 0 3 1 4 0 3 0 0 0 0 101zm173 -185l0 0 -1 10 0 9 -1 9 -2 9 -2 8 -2 9 -2 8 -3 9 -4 8 -3 8 -4 7 -5 8 -4 7 -5 7 -6 7 -5 6 -6 6 -6 6 -7 6 -7 5 -7 5 -7 4 -7 5 -8 3 -8 4 -8 3 -8 3 -9 2 -9 1 -9 2 -8 0 -10 1 0 -101 4 0 3 0 4 -1 3 0 3 -1 4 -1 3 -1 3 -2 3 -1 3 -2 3 -2 3 -2 3 -2 3 -2 2 -3 3 -3 2 -2 3 -4 2 -3 2 -3 2 -3 2 -4 2 -4 1 -3 2 -4 1 -4 1 -5 1 -4 1 -4 0 -5 1 -4 0 -5 0 0 100 0zm-173 -184l0 0 10 0 8 1 9 1 9 2 9 2 8 3 8 3 8 3 8 4 7 4 7 5 7 5 7 5 7 6 6 6 6 6 5 6 6 7 5 7 4 7 5 8 4 7 3 8 4 8 3 8 2 9 2 8 2 9 2 9 1 9 0 9 1 9 -100 0 0 -4 -1 -5 0 -4 -1 -4 -1 -5 -1 -4 -1 -4 -2 -4 -1 -4 -2 -3 -2 -4 -2 -3 -2 -4 -2 -3 -3 -3 -2 -3 -3 -2 -2 -3 -3 -2 -3 -2 -3 -3 -3 -1 -3 -2 -3 -2 -3 -1 -3 -1 -4 -1 -3 -1 -3 -1 -4 0 -3 0 -4 -1 0 0 0 -100z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil4",
    d: "M1400 897c-67,0 -122,60 -122,134 0,74 55,134 122,134 68,0 123,-60 123,-134 0,-74 -55,-134 -123,-134z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 1367,
    cy: 1033,
    r: 111
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 1334,
    cy: 1033,
    r: 43
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 862,
    cy: 1033,
    r: 43
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 1098,
    cy: 1300,
    r: 80
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "1173,1445 1173,1565 1022,1565 1022,1445 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str2",
    d: "M1097 1300c0,36 3,72 0,108 -4,54 -120,62 -127,-35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str2",
    d: "M1098 1300c0,36 -2,72 0,108 4,54 121,62 128,-35"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "fil0 str3",
    points: "1173,1445 1173,1565 1022,1565 1022,1445 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni4);
export default __webpack_public_path__ + "static/media/ani4.717bf9aca843cb7a6d446d90cf47551f.svg";
export { ForwardRef as ReactComponent };